import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import ReactDOM from 'react-dom';
var DropList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropList, _React$PureComponent);
  var _super = _createSuper(DropList);
  function DropList(props) {
    var _this;
    _classCallCheck(this, DropList);
    _this = _super.call(this, props);
    _this.handleClick = function (event) {
      if (_this.props.disabled) return;
      var container = _this.getContainer();
      if (container.contains(event.target)) {
        _this.toggle();
      } else {
        if (_this.state.dropdownOpen) {
          _this.setState({
            dropdownOpen: !_this.state.dropdownOpen
          });
        }
      }
    };
    _this.toggle = function () {
      _this.setState({
        dropdownOpen: !_this.state.dropdownOpen
      });
    };
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }
  _createClass(DropList, [{
    key: "getContainer",
    value: function getContainer() {
      return ReactDOM.findDOMNode(this);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var items = [];
      this.props.items.forEach(function (item, index) {
        items.push( /*#__PURE__*/React.createElement("button", {
          key: 'dropdown-item' + index,
          onMouseDown: item.handle,
          className: 'dropdown-item'
        }, item.icon ? /*#__PURE__*/React.createElement("i", {
          className: item.icon,
          style: {
            marginRight: '6px'
          }
        }) : null, item.text));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: 'custom-dropdown-list'
      }, /*#__PURE__*/React.createElement("div", {
        id: 'list_toggle',
        className: 'dropdown-list-toggle'
      }, /*#__PURE__*/React.createElement("i", {
        className: this.props.icon,
        style: {
          marginRight: '3px'
        }
      }), /*#__PURE__*/React.createElement("i", {
        className: this.state.dropdownOpen ? 'iconfont icon-caret-up' : 'iconfont icon-drop-down'
      })), this.state.dropdownOpen && /*#__PURE__*/React.createElement("div", {
        role: 'menu',
        className: 'custom-dropdown-menu dropdown-menu'
      }, items));
    }
  }]);
  return DropList;
}(React.PureComponent);
export default DropList;